import { render, staticRenderFns } from "./MyRequestNote.vue?vue&type=template&id=51d62058&lang=pug&"
import script from "./MyRequestNote.vue?vue&type=script&lang=js&"
export * from "./MyRequestNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports